import { Box, Button, Container } from '@mui/material'
import {Link} from 'react-router';

const VideoWelcome = ({sections, groupId}) => {

  return (
    <Container maxWidth="lg">
    <Box
      sx={{
        position: 'relative',
        paddingTop: '56.25%',
        my: { xs: 2, sm: 3, md: 4 },
        mx: { xs: 1, sm: 0 },
        borderRadius: { xs: "10px", md: "16px" },
        overflow: "hidden",
        backgroundColor: "#000",
        boxShadow: "0px 4px 20px rgba(0,0,0,0.2)"
      }}
    >
      <Box
        component="video"
        controls
        playsInline
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'contain'
        }}
      >
        <source src="/assets/videos/IntroAssessment.mp4" type="video/mp4" />
        Your browser does not support video playback.
      </Box>
    </Box>
    <Box display={"flex"} justifyContent={"center"}>
        <Button component={Link} to={groupId ? `/group/${groupId}/section/${sections[0]?._id}` : `/section/${sections[0]?._id}`} className='roundedB' variant='contained' color='primary'>START</Button>
    </Box>
    </Container>
  )
}

export default VideoWelcome
